module.exports = __webpack_public_path__ + "static_wap/img/xubao2.960b252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/xubao2.png
// module id = fHHP
// module chunks = 1